// BTC spot price in USD.
//
// Coinbase rather than CryptoCompare on purpose: this is called on pages that
// already spend a CryptoCompare quota elsewhere, and the spot endpoint needs no
// key. A missing price is never fatal - callers render the BTC figures and
// leave the dollar conversion out.
export const getBtcPrice = async () => {
  try {
    const response = await fetch(
      "https://api.coinbase.com/v2/prices/spot?currency=USD"
    );
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const json = await response.json();
    const price = parseFloat(json?.data?.amount);
    return Number.isFinite(price) ? price : 0;
  } catch (error) {
    // a missing price should not stop the rest of the page from rendering
    console.error("BTC spot price fetch failed:", error);
    return 0;
  }
};
